import React from "react";
import {NavLink} from "react-router-dom";
import * as Utils from "../../inc/Utils";
import ResearcherSidebar from "./ResearcherSidebar";
import {Config} from "../../Config";
import toast, {Toaster} from "react-hot-toast";
import {confirmAlert} from "react-confirm-alert";
import iconEdit from '../../img/icons/icon-pencil.svg';
import iconDelete from '../../img/icons/icon-trash.svg';

export default function ResearcherWork(prop) {

    let member = prop.member;

    let [listing, setListing] = React.useState(null);
    let [data, setData] = React.useState(null);

    React.useEffect(() => {
        window.scrollTo(0, 0);

        document.title = 'ข้อมูลนักวิจัย - ประวัติการทำงาน - NCSA';

        (async function() {
            try {
                if(member) {
                    const resResearcher = await Utils.getResearcherMember(member);
                    if(resResearcher.id) {
                        setData(resResearcher);
                        const result = await getListing(resResearcher.id);
                        setListing(result);
                    }
                }
            } catch (e) {
                //
            }
        })();

    }, []);

    async function getListing(researcherId) {
        const response = await fetch(Config.apiUrl +'/researcherWork/listMember', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                researcherId: researcherId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onDelete = (id) => {
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ต้องการลบข้อมูล ?',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: () => {
                        const body = {
                            id: id,
                        };
                        fetch(Config.apiUrl +'/researcherWork/deleteMember', {
                            method: 'POST',
                            body: JSON.stringify(body),
                            headers: {
                                'Content-Type':'application/json',
                                'x-access-token': member.accessToken
                            }
                        }).then(response => {
                            if(response.ok) {
                                return response.json();
                            }
                            else {
                                return response.json().then(err => Promise.reject(err));
                            }
                        }).then(async result => {
                            if(result) {
                                toast.success(prop.lang === 'en' ? 'Delete successfully':'ลบข้อมูลเรียบร้อย');
                                const result = await getListing(data.id);
                                setListing(result);
                            }
                        }).catch(err => {
                            toast.error(err.message);
                        })
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {}
                }
            ]
        });
    };

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <ResearcherSidebar active="work" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">

                            <div className="card-body p-0 px-xxl-3">
                                <h4 className="title-line-left mt-2 mb-3">{prop.lang === 'en' ? 'Researcher':'ข้อมูลนักวิจัย'}</h4>
                            </div>
                            <div className="d-flex justify-content-between gap-3">
                                <h6>{prop.lang === 'en' ? 'Work History':'ประวัติการทำงาน'}</h6>
                                {
                                    data !== null ?
                                        <NavLink
                                            to={(prop.lang === 'en' ? '/en' : '') + '/profile/researcher/work/create'}
                                            className="btn btn-xs btn-light-2">
                                            {prop.lang === 'en' ? '+ Add New' : '+ เพิ่มข้อมูล'}
                                        </NavLink> : <span className="text-danger">{prop.lang === 'en' ? 'Please update researcher info':'กรุณาอัพเดตข้อมูลนักวิจัย'}</span>
                                }
                            </div>

                            <div className="table-responsive mt-3">
                                <table className="table table-info table-hover text-center">
                                    <thead>
                                    <tr key={-2}>
                                        <th className="text-start">{prop.lang === 'en' ? 'Work History':'ประวัติการทำงาน'}</th>
                                        <th className="text-center" style={{width: '70px'}}>{prop.lang === 'en' ? 'Status':'สถานะ'}</th>
                                        <th className="text-center" style={{width: '100px'}}>{prop.lang === 'en' ? 'Created At':'วันที่สร้าง'}</th>
                                        <th className="text-center" style={{width: '100px'}}>{prop.lang === 'en' ? 'Updated At':'วันที่อัพเดต'}</th>
                                        <th style={{width: '100px'}}>{prop.lang === 'en' ? 'Status':'เครื่องมือ'}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        listing !== null && listing.rows.length > 0 ?
                                            listing.rows.map((row, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td className="text-start">
                                                            <span className="text-muted d-inline-block w130 text-end">ชื่อหน่วยงาน : </span> {row.company}<br />
                                                            <span className="text-muted d-inline-block w130 text-end">ตำแหน่ง :  </span> {row.position}<br />
                                                            <span className="text-muted d-inline-block w130 text-end">วันที่เริ่มทำงาน :  </span> {row.startDate ? Utils.dateTimeYMD(row.startDate) : '-'}<br />
                                                            <span className="text-muted d-inline-block w130 text-end">วันสิ้นสุดการทำงาน :  </span> {row.endDate ? Utils.dateTimeYMD(row.endDate) : '-'}
                                                        </td>
                                                        <td className={"text-center" + (row.status===1 ? ' text-success':' text-danger')}>
                                                            {row.status===1 ? 'ใช้งาน':'ระงับ'}
                                                        </td>
                                                        <td className="small">{Utils.dateTimeText(row.createdAt)}</td>
                                                        <td className="small">{Utils.dateTimeText(row.updatedAt)}</td>
                                                        <td className="text-center">
                                                            <div className="d-flex justify-content-center gap-2">
                                                                <NavLink to={(prop.lang === 'en' ? '/en':'') + '/profile/researcher/work/edit/' + Utils.encodeItem({id: row.id})} className="btn btn-trans">
                                                                    <img className="icons svg-js" src={iconEdit} alt="" />
                                                                </NavLink>
                                                                <button className="btn btn-trans" onClick={e => onDelete(row.id)}>
                                                                    <img className="icons svg-js trash" src={iconDelete} alt="" />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            }) :
                                            <tr key={-1}>
                                                <td colSpan={5} className="text-center">{prop.lang === 'en' ? 'No work submitted':'ยังไม่มีประวัติการทำงาน'}</td>
                                            </tr>
                                    }
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 